import {Component, EventEmitter, Input, Output} from "@angular/core";

/**
 * Show a help container and a close button
 */
@Component({
  selector: 'app-photovoltaikcheck-ergebnis-help',
  templateUrl: './ergebnis.help.component.html',
  providers: []
})
export class ErgebnisHelpComponent {
  /**
   * prefix for the textkey
   */
  @Input() textkeyprefix: string;

  /**
   * topic - part of the textkey
   */
  @Input() topic: string;

  /**
   * when the helptext shuld be closed
   */
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  /**
   * close the helptext
   */
  onClose(): void {
    this.close.emit();
  }
}
